import {post} from "./base";

export async function updateTrackingCode(accessToken, idRichiesta, trackingCode, type) {
    await post("richieste/UpdateTrackingCode", {jsonBody: {
        accessToken,
        idRichiesta,
        trackingCode,
        type,
    }});
    console.log(`Richiesta campioni ${idRichiesta} updated with tracking code ${trackingCode}`);
}

export async function retrieveTrackingCode(accessToken, idRichiesta, type) {
    const response = await post("richieste/RetrieveTrackingCode", {jsonBody: {
        accessToken,
        idRichiesta,
        type,
    }});
    console.log(`Richiesta campioni ${idRichiesta} retrieved with tracking code ${response.trackingCode}`);
    return response;
}
